export default {
  'companies.searchBar.button': 'Create New Company',
  'companies.list.header.name': 'Company Name',
  'companies.list.header.cnpj': 'CNPJ',
  'companies.list.header.situation': 'Situation',
  'companies.list.header.email': 'e-mail',
  'companies.list.header.phone': 'Phone Number',
  'companies.list.header.includedAt': 'Included At',
  'companies.list.header.actions': 'Actions',
  'companies.list.column.actions.button': 'View/Edit',
  'companies.general.form.name': 'Company Name',
  'companies.general.form.fantasyName': 'Fantasy Name',
  'companies.general.form.companyType': 'Company Type',
  'companies.general.form.companyType.mechanics': 'Mechanics',
  'companies.general.form.companyType.bodyShop': 'Body Shop',
  'companies.general.form.cnae': 'CNAE',
  'companies.general.form.webSite': 'WebSite',
  'companies.general.form.cnpj': 'CNPJ',
  'companies.general.form.municipalRegistration': 'Municipal Registration',
  'companies.general.form.stateRegistration': 'State Registration',
  'companies.general.form.taxRegime': 'Tax Regime',
  'companies.general.form.occupationArea': 'Occupation Area',
  'companies.general.form.cep': 'CEP',
  'companies.general.form.uf': 'UF',
  'companies.general.form.city': 'City',
  'companies.general.form.district': 'District',
  'companies.general.form.street': 'Street',
  'companies.general.form.number': 'Number',
  'companies.general.form.complement': 'Complement',
  'companies.general.form.zone': 'Zone',
  'companies.general.form.observation': 'Observations',
  'companies.general.form.contacts': 'Contacts',
  'companies.general.form.contacts.value': 'Contact',
  'companies.general.form.contacts.contactType': 'Contact Type',
  'companies.settings.form.stock': 'Stock',
  'companies.settings.form.stockOptions.ipiPercentage': 'IPI Percentage',
  'companies.settings.form.stockOptions.replacementValue': 'Replacement Value',
  'companies.settings.form.stockOptions.shippingCost': 'Shipping Cost',
  'companies.settings.form.stockOptions.valueOfIncidentalExpenses':
    'Value of incidental expenses',
  'companies.settings.form.stockOptions.fixedCostPercentual':
    'Fixed cost percentage',
  'companies.settings.form.fixedCost': 'Fixed Cost %',
  'companies.settings.form.fixedProfitPercentage': 'Fixed profit percentage %',
  'companies.settings.form.stockAuto': 'Automatically write off stock?',
  'companies.settings.form.budget': 'Budget',
  'companies.settings.form.marginRef': '(%) Margin ref.',
  'companies.settings.form.pieceDiscount': '(%) Piece Discount',
  'companies.settings.form.serviceDiscount': '(%) Service Discount',
  'companies.settings.form.mandatoryKm': 'Required KM field',
  'companies.settings.form.prism': 'Prism field required',
  'companies.settings.form.tankLevel': 'Required Tank Level Field',
  'companies.settings.form.alwaysGenerateActivityByWorkOrder':
    'Always generate activity by work order',
  'companies.settings.form.isMechanicSheetAutoFill':
    'Automatic filling of items on the mechanics sheet',
  'companies.settings.form.generateFinancial': 'Generate Financial',
  'companies.settings.form.withInstallments': 'With Free Installments',
  'companies.settings.form.withInstallmentsPaymentConditions':
    'With installments linked to payment terms',
  'companies.settings.form.tokens': 'Tokens',
  'companies.settings.form.tokenCilia':
    'Security token for Cilia system imports',
  'companies.settings.form.tokenAudatexweb':
    'Security token for AudatexWeb system imports',
  'companies.settings.form.pieceCreate': 'Creation by part on budget',
  'companies.settings.form.paintingHourValue': '(US$) Value/time painting',
  'companies.settings.form.paintingArea': '(US$) Painting Area',
  'companies.settings.form.changeHourValue': 'Value/time change',
  'companies.settings.form.changeArea': 'Change Area',
  'companies.settings.form.repairHourValue': '(US$) Value/time repair',
  'companies.settings.form.repairArea': 'Repair Area',
  'companies.settings.form.budgetApi': 'Budget API',
  'companies.settings.form.budgetApiKey': 'API Key',
  'companies.settings.form.boschCheckList': 'Use bosch check-list?',
  'companies.settings.form.alwaysSendWorkOrdersToMyBcs':
    'Always send work orders to MyBCS',
  'companies.settings.form.receiveMyBcsEvents':
    'Always receive events from MyBCS.',

  'companies.create.notification.success': 'Sucess',
  'companies.create.notification.successDescription': 'Empresa created.',

  'companies.update': 'Update Company',
  'companies.update.notification.success': 'Success',
  'companies.update.notification.successDescription': 'Company updated.',

  'companies.customTerm.created.notification.successDescription':
    'Custom Terms created.',
  'companies.customTerm.update.notification.successDescription':
    'Custom Terms updated.',

  'companies.remove': 'Remove Company',
  'companies.remove.alert': 'Do you really want to remove the company:',
  'companies.remove.notification.success': 'Success',
  'companies.remove.notification.successDescription': 'Company removed.',
  'companies.remove.error.delete.constraint':
    'It is not possible to delete a company that is linked to another module!',

  'companies.settings.itemTags.entity.company': 'Company',
  'companies.settings.itemTags.entity.description': 'Description',
  'companies.settings.itemTags.entity.color': 'Color',

  'companies.settings.itemTags.create': 'Create Tag',
  'companies.settings.itemTags.create.notification.success': 'Success',
  'companies.settings.itemTags.create.notification.success.description':
    'Item Tag created.',

  'companies.settings.itemTags.update': 'Update Tag',
  'companies.settings.itemTags.update.notification.success': 'Success',
  'companies.settings.itemTags.update.notification.success.description':
    'Item Tag updated.',

  'companies.settings.itemTags.remove': 'Remove Item Tag',
  'companies.settings.itemTags.remove.confirm.title': 'Remove Item Tag',
  'companies.settings.itemTags.remove.confirm.content':
    'Do you really want to remove the item tag?',
  'companies.settings.itemTags.remove.success.message': 'Success',
  'companies.settings.itemTags.remove.success.description': 'Item Tag removed.',
  'companies.settings.itemTags.errors.workorder_item_tag_use':
    'It is not possible to remove the Budget Tag, as it already has a link.',

  'companies.settings.priceComposition': 'Price Composition',

  'companies.settings.priceComposition.domain.fixedCost': '(%) Fixed cost',
  'companies.settings.priceComposition.domain.fixedProfitMargin':
    '(%) Fixed profit margin',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.ipi':
    'IPI percentage',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.tax_replacement':
    'Tax replacement',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.freight':
    'Freight',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.accessory':
    'Other Expenses',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.fixed_cost':
    'Fixed Cost',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.icms':
    'ICMS',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.operational':
    'Operational',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.profit_margin':
    'Calculate Profit Margin',

  'companies.settings.priceComposition.update.notification.success': 'Success',
  'companies.settings.priceComposition.update.notification.success.description':
    'Price composition updated.',

  'companies.customTerms.form.rgpdLabel': 'GDPR Terms',
  'companies.customTerms.form.responsability': 'Responsability Terms',
  'companies.customTerms.form.rgpdPlaceholder':
    'Insert here the Consent Term valid by your legal/accounting department.',
  'companies.customTerms.form.responsabilityPlaceholder':
    'Type the content of the disclaimer here',
  'companies.customTerms.form.warrantyLabel': 'Warranty Term',
  'companies.customTerms.form.warrantyPlaceholder':
    'Type here the content of the warranty term',
  'companies.customTerms.form.stayLabel': 'Declaration of permanence',
  'companies.customTerms.form.stayPlaceholder':
    'Enter here the content of the declaration of permanence',
  'companies.customTerms.form.dischargeLabel': 'Discharge term',
  'companies.customTerms.form.dischargePlaceholder':
    'Enter here the content of the discharge term',
  'companies.customTerms.form.signatureLabel':
    'declaration of the signature of the OS',
  'companies.customTerms.form.signaturePlaceHolder':
    'Enter here the personalized declaration of the signature of the OS. administrative reports',
  'companies.customTerms.form.partsSuppliedLabel': 'Term Parts supplied',
  'companies.customTerms.form.responsabilityLabel': 'Term of responsability',
  'companies.customTerms.form.partsSuppliedPlaceholder':
    'Enter here the content of the supplied part term',
  'companies.customTerms.form.plateSealCutTerms': 'Plate stamp cutting term',
  'companies.customTerms.form.plateSealCutTermsPlaceholder':
    'Enter the contents of the plate stamp cutting term here',

  'companies.customTerms.invoice.form.emissionEnvironment':
    'Issuance environment',
  'companies.customTerms.invoice.form.emissionEnvironment.production':
    'Production',
  'companies.customTerms.invoice.form.emissionEnvironment.homologation':
    'Homologation',
  'companies.customTerms.invoice.form.noteType': 'Note Type',
  'companies.customTerms.invoice.form.noteType.issueInvoice': 'Issue Invoice',
  'companies.customTerms.invoice.form.noteType.issueConsumerInvoice':
    'Issue Consumer Invoice',
  'companies.customTerms.invoice.form.noteType.issueTaxCoupon':
    'Issue Tax Coupon - SAT',
  'companies.customTerms.invoice.form.noteType.issueCombinedInvoice':
    'Issue Conjugated Invoice',
  'companies.customTerms.invoice.form.noteType.typeOfDigitalCertificate':
    'Type of Digital Certificate',
  'companies.customTerms.invoice.form.noteType.uploadToSystem':
    'Upload to System',
  'companies.customTerms.invoice.form.noteType.installedOnTheMachine':
    'Installed on the Machine',
  'companies.customTerms.invoice.form.useUnife': 'Use Unife',
  'companies.customTerms.invoice.form.digitalCertificateA1':
    'Digital Certificate A1',

  'companies.customTerms.invoice.form.owner': 'Owner',
  'companies.customTerms.invoice.form.homeValidity': 'Home Validity',
  'companies.customTerms.invoice.form.endValidity': 'End Validity',
  'companies.customTerms.invoice.form.modal.title':
    'Upload Digital Certificate',
  'companies.customTerms.invoice.form.info':
    'Check which types of invoice your company issues',
  'companies.customTerms.invoice.form.upload.msg': 'click or drag',
  'companies.customTerms.invoice.form.certificatePassword':
    'Certificate Password',

  'companies.customTerms.invoice.form.field.invoice': 'Invoice',
  'companies.customTerms.invoice.form.field.invoice.model': 'Model',
  'companies.customTerms.invoice.form.field.invoice.series': 'Series',
  'companies.customTerms.invoice.form.field.invoice.cfop': 'CFOP',
  'companies.customTerms.invoice.form.field.invoice.enforceability':
    'Enforceability ISS',
  'companies.customTerms.invoice.form.field.invoice.LastGeneratedNFe':
    'Last Generated NF-e',
  'companies.customTerms.invoice.form.field.invoice.generateInvoice':
    'Generate parts franchise invoice',
  'companies.customTerms.invoice.form.field.invoice.generateInvoice.info':
    'When this field is checked, every budget with a deductible greater than the service value generates a deductible note for parts',
  'companies.customTerms.invoice.form.field.invoice.generateTag':
    'Generate "infRespTec" tag in NF-e XML',
  'companies.customTerms.invoice.form.field.invoice.idCsrt': 'ID CSRT',
  'companies.customTerms.invoice.form.field.invoice.securityCode':
    'Technical Responsible Security Code',

  'companies.customTerms.invoice.form.field.invoiceCustomer':
    'Nota Fiscal de Consumidor',
  'companies.customTerms.invoice.form.field.invoiceCustomer.model': 'Modelo',
  'companies.customTerms.invoice.form.field.invoiceCustomer.series': 'series',
  'companies.customTerms.invoice.form.field.invoiceCustomer.securityCode':
    'security code',
  'companies.customTerms.invoice.form.field.invoiceCustomer.LastGeneratedNFCe':
    'Last generated NFC-e',
  'companies.customTerms.invoice.form.field.invoiceCustomer.cldToken':
    'cldToken',
  'companies.customTerms.invoice.form.field.invoiceCustomer.sendNFCe':
    'Send NFC-e using synchronous process',

  'companies.customTerms.invoice.form.field.issueTaxCoupon': 'SAT Tax Coupon',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.version':
    'Version',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.cashierNumber':
    'cashier Number',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.serialNumber':
    'serialNumber',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.activationCode':
    'activation Code',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.subscriptionKey':
    'Subscription Key',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.btn.addEquipment':
    'Add Equipment',

  'companies.customTerms.invoice.form.field.irpjCsllConfiguration':
    'IRPJ AND CSLL Configuration',
  'companies.customTerms.invoice.form.field.irpjCsllConfiguration.aliquotService':
    'IRPJ rate - Service',
  'companies.customTerms.invoice.form.field.irpjCsllConfiguration.aliquotPart':
    'IRPJ rate - Piece',
  'companies.customTerms.invoice.form.field.irpjCsllConfiguration.aliquotCsll':
    'CSLL rate',

  'companies.customTerms.invoice.form.field.danfe': 'Danfe',
  'companies.customTerms.invoice.form.field.danfe.CodeDisplayDanfe':
    'Display code in Danfe',
  'companies.customTerms.invoice.form.field.danfe.manufacturerCode':
    'Manufacturer Code',
  'companies.customTerms.invoice.form.field.danfe.internalCode':
    'Internal Code',
  'companies.customTerms.invoice.form.field.danfe.barCode': 'Bar Code',
  'companies.customTerms.invoice.form.field.danfe.standardNFECode':
    'Standard NF-e Code (ex: CFOP5120)',

  'companies.customTerms.invoice.form.field.serviceInvoice': 'Service Invoice',
  'companies.customTerms.invoice.form.field.serviceInvoice.seriesService':
    'series',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet':
    'Special Tax Regime',

  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.microEnterprise':
    'Municipal Micro Enterprise',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.estimated':
    'Estimated',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.society':
    'Society of Professionals',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.cooperative':
    'Cooperative',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.mei':
    'MEI - National Singles',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.meepp':
    'ME EPP - Simples Nacional',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.yes':
    'Yes',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.no':
    'No',
  'companies.customTerms.invoice.form.field.serviceInvoice.municipalCode':
    'Municipal Tax Code',
  'companies.customTerms.invoice.form.field.serviceInvoice.ServiceCode':
    'Service List Code',
  'companies.customTerms.invoice.form.field.serviceInvoice.ISSWithholding':
    'ISS withholding',
  'companies.customTerms.invoice.form.field.serviceInvoice.deductISS':
    'Deduct ISS',
  'companies.customTerms.invoice.form.field.serviceInvoice.pisCofins':
    'PIS/COFINS withholding',
  'companies.customTerms.invoice.form.field.serviceInvoice.culturalIncentive':
    'Cultural Incentive',
  'companies.customTerms.invoice.form.field.serviceInvoice.taxPercentage':
    'Tax Percentage',
  'companies.customTerms.invoice.form.field.serviceInvoice.aliquotISSQN':
    'Standard ISSQN Rate',
  'companies.customTerms.invoice.form.field.serviceInvoice.issuanceNFSe':
    'NFS-e Issue System*',

  'companies.customTerms.invoice.form.field.additionalData': 'Additional data',
  'companies.customTerms.invoice.form.field.additionalData.NFeSale':
    'Additional NF-e sales data',
  'companies.customTerms.invoice.form.field.additionalData.NFeService':
    'Additional data NF-e service',
  'companies.customTerms.invoice.form.field.additionalData.NFeDevolution':
    'Additional data NF-e return',
  'companies.customTerms.invoice.form.field.additionalData.NFeEmail':
    'Additional data NF-e email',

  'companies.customTerms.invoice.form.field.authorizationDownloadXml':
    'Authorization to download xml',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.add':
    'Add',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal':
    'Inform the Authorization Data',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.cpfCnpj':
    'Cpf/Cnpj',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.physicalPerson':
    'Pessoa Física',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.legalPerson':
    'Pessoa Jurídica',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.email':
    'Email',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.action':
    'Action',

  'companies.customTerms.invoice.form.field.settingsIcms':
    'Default ICMS configuration',
  'companies.customTerms.invoice.form.field.settingsIcms.csosn': 'CSOSN',
  'companies.customTerms.invoice.form.field.settingsIcms.cstIcms': 'CST ICMS',

  'companies.customTerms.invoice.form.field.settingsIpi': 'Default PII setting',
  'companies.customTerms.invoice.form.field.settingsIpi.framingCode':
    'Cód. Enquadramento',
  'companies.customTerms.invoice.form.field.settingsIpi.cstIpi': 'CST IPI',
  'companies.customTerms.invoice.form.field.settingsIpi.aliquotIpi':
    'Aliquot IPI',

  'companies.customTerms.invoice.form.field.settingsPis':
    'Default PIS configuration',
  'companies.customTerms.invoice.form.field.settingsPis.cstPis': 'CST PIS',
  'companies.customTerms.invoice.form.field.settingsPis.aliquotPis':
    'Aliquot PIS',

  'companies.customTerms.invoice.form.field.settingsCofins':
    'Default COFINS configuration',
  'companies.customTerms.invoice.form.field.settingsPis.cstCofins':
    'CST COFINS',
  'companies.customTerms.invoice.form.field.settingsPis.aliquotCofins':
    'Aliquot COFINS',

  'companies.create.notifications.success.title': 'Success',
  'companies.create.notifications.success.description':
    'Invoice configuration created.',
  'companies.create.notifications.success.description.edit':
    'Invoice configuration edited.',
  'companies.status.message.success': 'Company Status successfully changed!',

  'companies.sintegra.structure': 'Cod. Sintegra Structure Identification',
  'companies.sintegra.structure.icms30':
    '1 - Structure in accordance with the ICMS Agreement 57/95, in the version established by the ICMS Agreement 31/99 and with the changes promoted up to the ICMS Agreement 30/02.',
  'companies.sintegra.structure.icms142':
    '2 - Structure according to the ICMS Agreement 57/95, in the version established by the ICMS Agreement 69/02 and with the changes promoted by the ICMS Agreement 142/02.',
  'companies.sintegra.structure.icms76':
    '3 - Structure according to the ICMS Agreement 57/95, with the changes promoted by the ICMS Agreement 76/03.',
  'companies.sintegra.nature': 'code Identification Nature Sintegra',
  'companies.sintegra.nature.interstates':
    '1 - Interstate only transactions subject to the Tax Replacement regime',
  'companies.sintegra.nature.totalityOperations':
    '2 - All of the informants operations',
  'companies.sintegra.name': 'name',
  'companies.sintegra.telephone': 'telephone',
  'companies.sintegra.record51': 'Generate Type 51 record',
  'companies.sintegra.record53': 'Generate Type 53 record',

  'companies.Report.form.administrativeReport': 'Administrative Report',
  'companies.Report.form.workshopReport': 'Workshop Report',
  'companies.Report.form.quoteMapReport': 'Quote Map report',
  'companies.Report.form.administrativeReport.a4': 'Standard A4 297 x 210 mm',
  'companies.Report.form.administrativeReport.continuousForm':
    'Continuous Form 210 x 280 mm',
  'companies.Report.form.administrativeReport.thermal': '80mm thermal printer',
  'companies.Report.form.administrativeReport.58.thermal':
    '58mm thermal printer',

  'companies.Report.form.check.DisplayNoteReport': 'Display note in report',
  'companies.Report.form.check.ShowEngine': 'Show Engine',

  'companies.Report.form.radio.title':
    'Default name to be displayed on reports',
  'companies.Report.form.radio.corporateReason': 'Corporate Name',
  'companies.Report.form.radio.fantasyName': 'Fantasy name',
};
